import fetchClient from '../components/common/FetchClient';
import { clearOrderDataFromLocalStorage } from '../components/common/ResetOrderPlannerData';

const requestOrderPlannerSubmissionType = 'REQUEST_ORDERPLANNER_SUBMISSION_MODE';
const receiveOrderPlannerSubmissionType = 'RECEIVE_ORDERPLANNER_SUBMISSION_MODE';
const errorOrderPlannerSubmissionType = 'ERROR_ORDERPLANNER_SUBMISSION_MODE';

const initialState = {
    isLoading: false,
    salesStatus: '',
    salesOrderNum: '',
    submissionStatus: 'Pending Submission...'
};

export const actionCreators = {
    queryOrderSubmission: queryData => async (dispatch, getState) => {

        dispatch({ type: requestOrderPlannerSubmissionType });

        const url = `/api/OrderPlannerSubmission/SubmitOrder`;

        var items = [];

        for (var key in localStorage) {
            if (key.includes('order:')) {
                var itemInfoCsv = key.replace('order:', '');

                items.push(itemInfoCsv + ';' + localStorage.getItem(key));
            }
        }

        await fetchClient(url, {
            params: {
                azureToken: '',
                customerId: localStorage.getItem('customer'),
                contactId: localStorage.getItem('orderPlannerContact'),
                addressId: localStorage.getItem('address'),
                dlvModeId: localStorage.getItem('deliveryModeCode'),
                deliveryDate: new Date(localStorage.getItem('deliveryDate')).toISOString().substring(0, 10),
                poNumber: localStorage.getItem('orderPO'),
                orderItems: JSON.stringify(items),
                specialInstructions: localStorage.getItem('specialInstructions'),
                isSalesQuote: localStorage.getItem('isSalesQuote') === true || localStorage.getItem('isSalesQuote') === 'true' ? true : false,
                shipComplete: localStorage.getItem('shipComplete') === true || localStorage.getItem('shipComplete') === 'true' ? true : false
            }})
            .then(function (resp) {
                console.log(resp);
                if (resp) {

                    var orderData = resp.data.SubmitOrderReqResp.OrderInformation;
                    console.log('orderData', orderData);
                    if (orderData === null) {

                        var error = resp.data.SubmitOrderReqResp.ResponseCode.Msg;
                        console.log(error);
                        dispatch({
                            type: errorOrderPlannerSubmissionType,
                            error
                        });

                        return;
                    }

                    var salesOrderNum = orderData.SalesId;
                    var salesStatus = orderData.SalesStatus;

                    clearOrderDataFromLocalStorage(false);

                    dispatch({
                        type: receiveOrderPlannerSubmissionType,
                        salesStatus,
                        salesOrderNum
                    });
                }
            });
    },

};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === requestOrderPlannerSubmissionType) {

        return {
            ...state,
            isLoading: true,
            submissionStatus: 'Submitting...'
        };
    }

    if (action.type === receiveOrderPlannerSubmissionType) {
        return {
            ...state,
            salesStatus: action.salesStatus,
            salesOrderNum: action.salesOrderNum,
            isLoading: false,
            submissionStatus: 'Submitted'
        };
    }

    if (action.type === errorOrderPlannerSubmissionType) {
        return {
            ...state,
            salesStatus: "Error",
            salesOrderNum: action.error,
            isLoading: false,
            submissionStatus: 'Order Error'
        };
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/store/OrderPlannerSubmit.js